import { Route, BrowserRouter, Routes } from 'react-router-dom';
import './App.css';
import Login from './pages/LoginToken/LoginToken';
import { LoadingProvider } from './utils/spinner';
import Top from './pages/Top/Top';
import { SCREEN_ROUTER } from './constants/screenRouter';
import Header from './components/Header';
import LoginCookie from './pages/LoginCookie/LoginCookie';
import LoginAccount from './pages/LoginAccount/LoginAccount';
import DashBoard from './pages/Dashboard/Dashboard';
import { ToastProvider } from './contexts/ToastProvider';

function App() {
  return (
    <div className="App">
      <ToastProvider>
        <LoadingProvider>
          <BrowserRouter>
            <Header />
            <Routes>
              <Route path={SCREEN_ROUTER.LOGIN_TOKEN} element={<Login />} />
              <Route path={SCREEN_ROUTER.LOGIN_METHOD} element={<Top />} />
              <Route path={SCREEN_ROUTER.LOGIN_COOKIE} element={<LoginCookie />} />
              <Route path={SCREEN_ROUTER.LOGIN_ACCOUNT} element={<LoginAccount />} />
              <Route path={SCREEN_ROUTER.DASH_BOARD} element={<DashBoard />} />
            </Routes>
          </BrowserRouter>
        </LoadingProvider>
      </ToastProvider>
    </div>
  );
}

export default App;
